"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncate = void 0;
var truncate = function (text, number) {
    if (text === void 0) { text = ""; }
    return (text === null || text === void 0 ? void 0 : text.length) > 100 ? text.slice(0, number) + "..." : text;
};
exports.truncate = truncate;
